import * as React from "react";
const SvgRankNeutral = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8.00004, cy: 7.99992, r: 5.83333, stroke: "#91939A", strokeWidth: 1.66667 }));
export default SvgRankNeutral;
